'use strict';
module.exports = typeof navigator !== 'undefined' && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-firefox/index.js
// module id = ./node_modules/is-firefox/index.js
// module chunks = 1 2 3